import React from 'react';
import { render } from '@wordpress/element';
import ClassicCheckoutApp from './ClassicCheckoutApp';
import "./store";

/**
 * Render the subscription field for the classic checkout.
 */
if (document.getElementById('iconic-wds-subscription-field')) {
	render( <ClassicCheckoutApp />, document.getElementById( 'iconic-wds-subscription-field' ) );
}
